import router from '@/routers'
import utils from './index'
import isempty from 'lodash.isempty'
import transform from 'lodash.transform'
export default {
  navTo(target, item) { // 路由（页面）之间基于vue-router带参数的跳转
    if (target) {
      var str = (item) ? target.path + '/' : target
      var str2 = (item) ? '?' : ''
      if (target.params) {
        if (isempty(item)) {
          str += 'createnew'
        } else {
          for (var i = 0; i < target.params.length; i++) {
            let p = target.params[i]
            let v = item[p]
            str += v + '/'
          };
        }
      }
      if (target.query) {
        for (var i = 0; i < target.query.length; i++) {
          let p = target.query[i]
          let v = item[p]
          str2 += p + '=' + v + '&'
        };
      }
      router.push({
        path: ((item) ? utils.trimTail(str, '/') : str) + str2
      })
    }
  },
  openDialog ($modal, o, model, scope) {
    $modal.show('dialog', {
      title: o.title,
      text: o.text,
      buttons: [
        {
          title: '确认',
          default: true,
          handler: utils.debounce(() => {
            if (o.yes && o.yes instanceof Function) {
              o.yes(model, scope)
              $modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
            }
          }, 1000)
        },
        {
          title: '取消'
        }
      ]
    })
  },
  getVueChildComponent(arr, componentName) { // 获取vue的子组件
    return arr.filter((child) => {
      return child.$options._componentTag == componentName
    })
  },
  formValidate (arr, rootComponent, callback) {
    let RegisterComponent = this.getVueChildComponent(arr, rootComponent)
    let FormItemComponent = this.getVueChildComponent(RegisterComponent[0].$children, 'FormItem')

    let validationArray = transform(FormItemComponent, (result, n) => {
      let validateResult = this.getValidationResults(n.$children, 'Input')[0]
      if (validateResult) { // 有些FormItem没有设置rules
        result.push(validateResult)
      }
    }, []);

    window.Promise.all(validationArray).then((v) => {
      let isAllValid = (v.filter((e) => {
        return e == true
      }).length == v.length)
      if (isAllValid) {
        if (callback) {
          callback()
        }
      }
    }).catch((err) => {
      console.log(err)
    });
  },
  getValidationResults(arr, componentName) { // 表单验证
    var items = this.getVueChildComponent(arr, componentName)
    var validationArray = items.map(function(child) {
      return child.$validator.validateAll();
    });
    return validationArray
  }
}



// WEBPACK FOOTER //
// ./src/utils/projCommon.js